<template>
  <a-drawer :destroy-on-close="true" :title="isUpdate ? '云服务器编辑' : '云服务器创建'" :visible="visible" :width="800"
    @close="closeDrawer">
    <a-form-model ref="form" :label-col="{
      span: 4,
      style: {
        textAlign: 'left'
      }
    }" :model="form" :rules="rules" :wrapper-col="{
      span: 20
    }">
      <a-form-model-item label="云服务商" prop="vendor">
        <a-input v-model="form.vendor" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="云主机区域" prop="location">
        <a-input v-model="form.location" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="业务系统名称" prop="service">
        <service-select v-model="form.service"></service-select>
      </a-form-model-item>

      <a-form-model-item label="当前业务系统名称" prop="added_service">
        <service-select v-model="form.added_service"></service-select>
      </a-form-model-item>
      <a-form-model-item label="服务器架构" prop="architecture">
        <a-select v-model="form.architecture" :options="architectureOptions"></a-select>
      </a-form-model-item>
      <a-form-model-item label="CPU" prop="cpu">
        <a-input v-model="form.cpu" type="number" min="1" suffix="核"></a-input>
      </a-form-model-item>
      <a-form-model-item label="内存" prop="memory">
        <a-input v-model="form.memory" type="number" min="1" suffix="GB"></a-input>
      </a-form-model-item>
      <a-form-model-item label="普通存储" prop="disk">
        <a-input v-model="form.disk" type="number" min="0" suffix="GB"></a-input>
      </a-form-model-item>
      <a-form-model-item label="SSD 存储" prop="ssd">
        <a-input v-model="form.ssd" type="number" min="0" suffix="GB"></a-input>
      </a-form-model-item>
      <a-form-model-item label="带宽" prop="bandwidth">
        <a-input v-model="form.bandwidth" type="number" min="0" suffix="MB"></a-input>
      </a-form-model-item>
      <a-form-model-item label="主机名" prop="name">
        <a-input v-model="form.name" :max-length="128"></a-input>
      </a-form-model-item>


      <a-form-model-item label="云主机内网 IPV4" prop="privateIp">
        <a-input v-model="form.privateIp" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="云主机内网 IPV6" prop="privateIpv6">
        <a-input v-model="form.internalIpv6" :max-length="128"></a-input>
      </a-form-model-item>

      <a-form-model-item label="一次NAT转换地址" prop="natIp">
        <a-input v-model="form.natIp" :max-length="16"></a-input>
      </a-form-model-item>

      <a-form-model-item label="冗余 IP" prop="multiIp">
        <a-input v-model="form.multiIp" :max-length="128"></a-input>
      </a-form-model-item>



      <a-form-model-item label="操作系统" prop="os">
        <a-input v-model="form.os" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="资源申请人" prop="applicant">
        <a-input v-model="form.applicant" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="资源申请人联系电话" prop="applicantPhone">
        <a-input v-model="form.applicantPhone" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="资源下发时间" prop="allocatedAt">
        <a-date-picker v-model="form.allocatedAt" style="width: 100%"></a-date-picker>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="comment">
        <a-input v-model="form.comment"></a-input>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 20, offset: 4 }" style="margin-bottom: 0">
        <a-space size="middle">
          <a-button :loading="loading" type="primary" @click="ok">
            确定
          </a-button>
          <a-button @click="closeDrawer">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </a-drawer>
</template>

<script>
import moment from 'moment'
import {
  getHostInventory,
  updateHostInventory,
  createHostInventory
} from '@/api/inventory.js'
import ServiceSelect from './ServiceSelect.vue'

export default {
  name: 'InputDrawer',
  components: {
    ServiceSelect
  },
  data() {
    return {
      architectureOptions: [
        {
          label: 'X86',
          value: 'x86'
        },
        {
          label: 'ARM',
          value: 'arm'
        }
      ],
      visible: false,
      isUpdate: false,
      form: {
        id: '',
        vendor: '',
        location: '',
        service: undefined,
        added_service: undefined,
        // update 0625
        architecture: '',
        natIp: '',
        internalIpv6: '',
        // update 0625

        cpu: '',
        memory: '',
        disk: '',
        ssd: '',
        bandwidth: '',
        name: '',
        privateIp: '',
        multiIp: '',
        os: '',
        applicant: '',
        applicantPhone: '',
        allocatedAt: undefined,
        comment: ''
      },
      rules: {
        name: [
          {
            message: '请输入主机名',
            required: false,
            trigger: 'blur'
          }
        ],
        privateIp: [
          {
            message: '请输入云主机内网 IP',
            required: true,
            trigger: 'blur'
          }
        ],

        comment: [
          {
            max: 150,
            message: '备注长度不能超过150个字符',
            trigger: 'blur'
          }
        ]
      },
      loading: false,
      serviceOptions: []
    }
  },
  methods: {
    show(id) {
      if (id) {
        this.isUpdate = true
        getHostInventory(id)
          .then(res => {
            const data = res.data
            this.form = {
              id: data.id,
              vendor: data.vendor,
              location: data.location,
              service: data.service ? data.service : undefined,
              added_service: data.added_service ? data.added_service : undefined,
              cpu: data.cpu,
              memory: data.memory,
              disk: data.disk,
              ssd: data.ssd,
              bandwidth: data.bandwidth,
              name: data.name,
              privateIp: data.private_ip,
              multiIp: data.multi_ip,
              os: data.os,
              applicant: data.applicant,
              applicantPhone: data.applicant_phone,
              allocatedAt: data.allocated_at ? moment(data.allocated_at, 'YYYY-MM-DD') : undefined,
              comment: data.comment,
              // update 0625
              architecture: data.architecture,
              internalIpv6: data.internal_ipv6,
              natIp: data.nat_ip
            }
          })
          .finally(() => {
            this.visible = true
          })
      } else {
        this.isUpdate = false
        this.visible = true
      }
    },
    closeDrawer() {
      this.form = {
        id: '',
        vendor: '',
        location: '',
        service: undefined,
        added_service: undefined,
        cpu: '',
        memory: '',
        disk: '',
        ssd: '',
        bandwidth: '',
        name: '',
        privateIp: '',
        multiIp: '',
        os: '',
        applicant: '',
        applicantPhone: '',
        allocatedAt: undefined,
        comment: '',
        // update 0625
        architecture: '',
        internalIpv6: '',
        natIp: ''
      }
      this.serviceOptions = []
      this.isUpdate = false
      this.$refs.form.resetFields()
      this.visible = false
    },
    ok() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          const params = {
            name: this.form.name,
            private_ip: this.form.privateIp
          }
          if (this.form.vendor) params.vendor = this.form.vendor
          if (this.form.location) params.location = this.form.location
          if (this.form.service) params.service_id = this.form.service.id
          if (this.form.added_service) params.added_service_id = this.form.added_service.id
          if (this.form.cpu) params.cpu = this.form.cpu
          if (this.form.memory) params.memory = this.form.memory
          if (this.form.disk) params.disk = this.form.disk
          if (this.form.ssd) params.ssd = this.form.ssd
          if (this.form.bandwidth) params.bandwidth = this.form.bandwidth
          if (this.form.multiIp) params.multi_ip = this.form.multiIp
          if (this.form.os) params.os = this.form.os
          if (this.form.applicant) params.applicant = this.form.applicant
          if (this.form.applicantPhone) params.applicant_phone = this.form.applicantPhone
          if (this.form.comment) params.comment = this.form.comment
          if (this.form.allocatedAt) params.allocated_at = this.form.allocatedAt.format('YYYY-MM-DD')
          if (this.form.architecture) params.architecture = this.form.architecture
          if (this.form.internalIpv6) params.internal_ipv6 = this.form.internalIpv6
          if (this.form.natIp) params.nat_ip = this.form.natIp
          if (this.isUpdate) {
            updateHostInventory(this.form.id, params)
              .then(res => {
                this.$message.success(res.message)
                this.$emit('ok')
                this.closeDrawer()
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            createHostInventory(params)
              .then(res => {
                this.$message.success(res.message)
                this.$emit('ok')
                this.closeDrawer()
              })
              .finally(() => {
                this.loading = false
              })
          }
        }
      })
    }
  }
}
</script>
